import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { cookieDomain: String };

  dismiss() {
    const expires = new Date();
    expires.setDate(expires.getDate() + 365);
    // Domain-scoped so dismissal survives switching to another location group's subdomain.
    document.cookie =
      `mo_dashboards_announcement_dismissed=true; path=/admin; domain=${this.cookieDomainValue}; ` +
      `expires=${expires.toUTCString()}; SameSite=Lax`;
  }
}
